module.exports = __webpack_public_path__ + "static/74th-d5a17380212bd62f18b891ae65b8bf4c.png";